
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util';
import header1 from '@/components/headers/header.vue';
import footer1 from '@/components/footers/footer.vue';
import Vendor from '@/store/entities/auth/Vendor';
import CooperationModeRadios from '@/components/cooperation-mode-radios.vue';
import common from '@/lib/common';
import Store from '@/store/index';
import UserProfile from '@/store/entities/auth/UserProfile';

@Component({
    components: { header1, footer1, CooperationModeRadios }
})
export default class shopRegister extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    editMode: string;
    currentTab: string = "detail";
    title: string = this.L('Vendor');
    vendor: Vendor = new Vendor();
    editorOptions: any = {
        plugins: 'image',
        image_uploadtab: true,
        height: 400,
        images_upload_handler: function (blobInfo, success, failure) {
            var formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('usage', 'AuthVendorEditors');
            var location = Store.dispatch({
                type: 'imageManager/uploadImage',
                data: formData
            });
            success(location);
        }
    };
    uploadHeaders: any = {
        Authorization: "Bearer " + Util.abp.auth.getToken(),
        TenantId: Util.abp.multiTenancy.getTenantIdCookie()
    };
    uploadUrl: string = '';
    isActiveVisible: boolean = abp.auth.isGranted("Pages.Vendor.Edit.IsActive");
    saveLoading: boolean = false;
    isReadMustKnowAbout: Boolean = true;
    validateVendorDisplayName = (rule, value, callback) => {
        if (!value || value === '') {
            callback(new Error(this.L('FieldIsRequired')));
        } else {
            this.$store.dispatch({
                type: 'vendor/existsDisplayName',
                data: value
            }).then(data => {
                if (data) {
                    callback(new Error('存在同名'));
                } else {
                    callback();
                }
            });
        }
    };
    vendorRule = {
        displayName: [{ validator: this.validateVendorDisplayName, required: true, trigger: 'blur' }],
        identificationCardImageUrl: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('IdentificationCardImageUrl')), trigger: 'blur' }],
        cooperationMode: [{ required: true, message: this.L('FieldIsRequired', undefined, this.L('CooperationMode')), trigger: 'blur' }],
    };
    userProfile: UserProfile = new UserProfile();

    save() {
        (this.$refs.vendorForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.saveLoading = true;
                await this.$store.dispatch({
                    type: 'vendor/register',
                    data: this.vendor
                }).then(() => {
                    this.$emit('save-success');
                    this.$emit('input', false);
                    this.saveLoading = false;
                    this.$Message.success(this.L('SavedSuccessfully'));
                    this.$router.push('/pc/home');
                }).catch((err) => {
                    if (err.toString().indexOf('409') > -1) {
                        this.$Message.error(this.L('VendorAlreadyExisting'));
                    }
                    this.saveLoading = false;
                });
            }
        })
    }

    created() {
        this.$store.dispatch({
            type: 'userProfile/getByUserNo',
            data: Util.abp.session.getUserNoCookie()
        }).then(data => {
            this.userProfile = data;
            this.checkVendor();
            this.checkUserProfile();
        });
    }

    mounted() {
        this.$store.commit('app/hideSidebarMenu');
        this.uploadUrl = common.getUploadUrl('AuthVendor');
        let model = new Vendor();
        model.cooperationMode = '独家销售';
        model.userName = Util.abp.session.getPhoneNumberCookie();
        this.vendor = Util.extend(true, {}, model);
    }
    checkVendor() {
        this.$store.dispatch({
            type: 'vendor/getByUserNo',
            data: Util.abp.session.getUserNoCookie()
        }).then((data) => {
            if (data) {
                this.$Modal.warning({
                    title: this.L('SystemTips'),
                    content: this.L('VendorAlreadyExisting'),
                    onOk: () => {
                        this.$router.push('/pc/home');
                    }
                });
            }
        })
    }
    checkUserProfile() {
        if (!this.userProfile.identificationCardNo || !this.userProfile.fullName) {
            this.$Modal.confirm({
                title: this.L('SystemTips'),
                content: '请先完善个人信息，确定前往完善？',
                onOk: () => {
                    this.$router.push('/pc/profile');
                },
                onCancel: () => {
                    window.history.go(-1);
                }
            });
        }
    }
    handleBeforeUpload(file) {
        var validationResult = Util.validateImageFile(file);
        if (!validationResult.result) {
            this.$Notice.warning({
                title: this.L('Tips'),
                desc: validationResult.msg
            });
            return false;
        }
        return true;
    }
    handleUploadSuccess4VendorImageUrl(res, file) {
        this.vendor.vendorImageUrl = res.result.location;
    }
    handleUploadSuccess4IdentificationCardImageUrl(res, file) {
        this.vendor.identificationCardImageUrl = res.result.location;
    }
    handleRemoveImage(fileName: string, onRemoved) {
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: '<div style="word-wrap:break-word">' + this.L("DeleteConfirm", fileName) + '</div>',
            onOk: () => {
                this.$store.dispatch({
                    type: 'imageManager/deleteImage',
                    data: {
                        imageUrl: fileName
                    }
                }).then(() => {
                    if (onRemoved) {
                        onRemoved();
                    }
                    this.$Notice.success({
                        title: this.L('Tips'),
                        desc: fileName + this.L('Delete') + this.L('Success')
                    });
                });
            }
        });
    }
}
